// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2KUBq","author":"Table_author__28So_","authorImage":"Table_authorImage__Heb7Y","unreadRow":"Table_unreadRow__2Pu5X"};